import React, { FC } from 'react';
import { useFormikContext } from 'formik';

import { ContentInput } from 'api';
import { Dimensions } from 'components';
import { DimensionsProvider } from 'providers';

import { getPhoto } from 'features/content/helpers';
import { Photo } from 'features/content/widgets';

const PhotoPreview: FC = () => {
  const { values } = useFormikContext<ContentInput>();
  const photo = getPhoto(values);

  if (!photo) {
    return null;
  }

  return (
    <Dimensions>
      {dimensions => (
        <DimensionsProvider value={{ dimensions }}>
          <Photo photo={photo} />
        </DimensionsProvider>
      )}
    </Dimensions>
  );
};

export default PhotoPreview;
